module.exports = __webpack_public_path__ + "img/bg1-blur.3aa8986.jpg";